import DocumentPreview from '../DocumentPreview';

import { ReceiptUploaderProps } from './ReceiptUploader.interface';

import { RoleScope } from 'modules/Tax/TaxPayment/constants';
import { Document } from 'modules/common/interfaces/documents';
import UppyUploaderFieldLazy from 'modules/common/components/UppyUploader/UppyUploaderFieldLazy';

function ReceiptUploader({
    onSuccess,
    onError,
    onReplaceFile,
    onResetForm,
    payment,
    trigger,
    values,
    roleScope = RoleScope.MEMBER,
}: ReceiptUploaderProps) {
    const endpoint = roleScope === RoleScope.MEMBER ? 'qte/member-tax-payments/' : 'qte/ms-tax-payments/';
    const params = payment ? `${payment.uuid}/` : '';
    const method = payment ? 'PUT' : 'POST';

    if (payment?.payment_receipt && !values.replace_file) {
        return <DocumentPreview payment={payment} onRemove={onReplaceFile} />;
    }

    const onFileAdded = (file) => {
        if (file) {
            onReplaceFile();
        }
    };

    const onUploadSuccess = (response: Document[]) => {
        if (response.length > 0) {
            onSuccess(response[0], onResetForm);
        }
    };

    return (
        <UppyUploaderFieldLazy
            documentType=""
            hideUploadButton
            shouldSetValueOnLocalState
            shouldPreloadData={false}
            doneButtonHandler={undefined}
            onFileAdded={onFileAdded}
            onUploadSuccess={onUploadSuccess}
            onUploadError={onError}
            label="Payment Receipt"
            name="file"
            meta={values}
            trigger={trigger}
            options={{
                restrictions: {
                    allowedFileTypes: ['image/*', 'application/pdf'],
                    maxNumberOfFiles: 1,
                },
            }}
            xhrOptions={{ endpoint: endpoint + params, method }}
        />
    );
}

export default ReceiptUploader;
